/**
    招采外嵌
**/
<template>
  <div class="header_logo">
    <div class="w w1200 main">
      <el-row>
        <el-col :span="19">
          <div class="main_left">
            <router-link class="contents" to="/">
              <el-image
                src="https://www.gstianze.com/center/profile/upload/2023/05/16/ad44b8ed55d89b0b7ae83b1151c76b31.png"
                fit="fill"
                style="width: 255px; height: 50px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </router-link>

            <span class="line"></span>
            <div>
              <h3 class="titles" @click="$router.push('/welcomesystem')">
                招采入驻
              </h3>
            </div>
          </div>
        </el-col>
        <el-col :span="5" class="phone">
          <p style="margin-top:15px">客服电话：400-011-9000</p>
        <p>邮箱：wangxiaolong@gsafety.com</p>
        </el-col>
      </el-row>
    </div>
    <div class="menuclass">
      <div class="w w1200">
        <el-menu
          background-color="#c6523f"
          mode="horizontal"
          router
          class="el-menu-vertical-demo"
        >
          <el-menu-item
            v-for="item in leftMenu"
            :key="item.id"
            :index="item.url"
          >
            <template slot="title"
              ><i :class="item.icon"></i>{{ item.menu }}</template
            >
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="middle">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      leftMenu: [
        {
          id: 1,
          menu: "商城首页",
          url: "/",
          icon: "el-icon-s-home",
        },
        {
          id: 2,
          menu: "招采平台",
          url: "/procurementTenders",
          icon: "",
        },
      ],
    };
  },
  computed: {
    ...mapState(["copyRight"]),
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {},
};
</script>

<style scoped lang="less">
.menuclass {
  width: 100%;
  height: 40px;
  background-color: #c6523f;
}
/deep/.el-menu-item {
  height: 40px;
  line-height: 40px;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #c6523f;
}
.main {
  height: 80px;
  .main_left {
    display: flex;
    height: 80px;
    align-items: center;

  }
  .line {
    margin-left: 10px;
    float: left;
    width: 2px;
    height: 40px;
    background-color: #eee;
    margin-right: 21px;
  }
  .titles {
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
  .phone {
      line-height: 80px;
   font-size :15px;
   
   p{

       height: 25px;
       line-height:25px;   }
  }
  
}

.el-menu-vertical-demo {
  height: 40px;
}
/deep/.el-menu--horizontal > .el-menu-item {
  height: 40px;
  line-height: 40px;
}
.header_logo {
  height: 100%;
  .xunyouText {
    width: 100px;
    height: auto;
  }
  li.el-menu-item {
    color: white !important;
    font-size: 16px;
    i {
      color: white;
      vertical-align: inherit;
    }
  }
}
.breakcrumbHeader {
  margin: 15px 0;
}
.bigtitle {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 2px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/procurementMg/procureNavigation.vue